<template>
    <div class="trainee-list-modal-overlay">
        <transition name="modal-expand">
            <div v-if="isVisible" class="trainee-list-modal" @click.stop>
                <div class="modal-content">
                    <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
                    <h2>Add Task</h2>
                    <div class="add">
                        <form @submit.prevent="addTask">
                            <div class="form-group">
                                <label for="chapt-no">Chapter No:</label>
                                <input type="text" class="form-control rounded" id="chapt-no" name="chapt-no"
                                    v-model="newTask.chapt_no" />
                            </div>

                            <div class="form-group">
                                <label for="task_no">Task No:</label>
                                <input type="text" class="form-control rounded" id="task-no" name="task-no"
                                    v-model="newTask.task_no" />
                            </div>

                            <div class="form-group">
                                <label for="manob">MT/AT:</label>
                                <select class="form-control rounded" id="manob" name="manob" v-model="newTask.manob">
                                    <option value="" disabled selected>Select MT/AT</option>
                                    <option value="MT">Main Task</option>
                                    <option value="AT">Additional Task</option>
                                </select>
                            </div>


                            <div class="form-group">
                                <label>Scope:</label>
                                <div class="scope-checkboxes">
                                    <label v-for="option in scopeOptions" :key="option" class="mr-2">
                                        <input type="checkbox" :value="option" v-model="newTask.scope" />
                                        {{ option }}
                                    </label>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="description">Description:</label>
                                <input type="text" class="form-control rounded" id="description" name="description"
                                    placeholder="Enter Task Description" v-model="newTask.description" />
                            </div>

                            <div class="form-group">
                                <label for="reference">Reference:</label>
                                <input type="text" class="form-control rounded" id="reference" name="reference"
                                    placeholder="Enter Task Reference" v-model="newTask.reference" />
                            </div>

                            <!-- <div class="form-group">
                <label for="est_time">Est. Time (minutes):</label>
                <input type="text" class="form-control rounded" id="est_time" name="est_time"
                  placeholder="Enter Est. Time" v-model="newTask.est_time" />
              </div> -->
                            <!-- 
                        <div class="form-group">
                            <label for="is_exam">Assessable:</label>
                            <select class="form-control rounded" id="is_exam" name="is_exam" v-model="newTask.is_exam">
                                <option value=""></option>
                                <option value="1">True</option>
                                <option value="0">False</option>
                            </select>
                        </div> -->

                        <div class="form-group">
                            <label for="manob">MT/AT:</label>
                            <select class="form-control rounded" id="manob" name="manob" v-model="newTask.manob">
                                <option value=""></option>
                                <option value="MT">Main Task</option>
                                <option value="AT">Additional Task</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label for="P1">P1:</label>
                            <select class="form-control rounded" id="P1" name="P1" v-model="newTask.P1">
                                <option value=""></option>
                                <option value="1">1</option>
                                <option value="0">0</option>
                            </select>
                        </div>

                            <div class="form-group">
                                <label for="category">Category:</label>
                                <select class="form-control rounded" id="category" name="category"
                                    v-model="newTask.category">
                                    <option value=""></option>
                                    <option value="B1">B1</option>
                                    <option value="B2">B2</option>
                                    <option value="B1 B2">B1 B2</option>
                                </select>
                            </div>

                            <!-- <div class="form-group">
                <label for="level">Level:</label>
                <select class="form-control rounded" id="level" name="level" v-model="newTask.level">
                  <option value=""></option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                </select>
              </div> -->

                            <!-- <div class="form-group">
                <label for="is_exam">Is Exam:</label>
                <select class="form-control rounded" id="is_exam" name="is_exam" v-model="newTask.is_exam">
                  <option value=""></option>
                  <option value="0">0</option>
                  <option value="1">1</option>
                </select>
              </div> -->

                            <div v-if="showAlert" class="alert alert-danger error-message" role="alert">
                                <div v-if="errorMessage">{{ errorMessage }}</div>
                            </div>
                            <div>
                                <button class="btn btn-primary rounded" type="submit" style="margin-top: 10px;">Add
                                    Task</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

import axios from 'axios';
import { EXTRA_TASK_SCOPES } from '@/config/featureFlags';

export default {
    data() {
        return {
            instructors: [],
            products: [],
            tasks: [],
            newTask: {
                task_no: '',
                reference: '',
                manob: '',
                scope: [],
                description: '',
                chapt_no: '',
                category: '',
                //skill: '',
                P1: '',
            },
            showAlert: false,
            currentTime: '',
            errorMessages: {},
            errorMessage: '',
            productSelected: false,
            taskSelected: false,
            showTraineeList: false,
            isVisible: false,
            scopeOptions: ['LOC', 'SGH', 'TS', 'FOT', 'MEL', 'R/I', ...EXTRA_TASK_SCOPES],
        };
    },
    methods: {
        async addTask() {
            try {
                if (!this.newTask.task_no) {
                    const tasksInChapter = this.tasks.filter(
                        task => task.chapt_no === this.newTask.chapt_no
                    );

                    if (tasksInChapter.length > 0) {
                        // Get max task_no from this chapter
                        const maxTaskNo = Math.max(
                            ...tasksInChapter.map(t => parseInt(t.task_no) || 0)
                        );
                        this.newTask.task_no = (maxTaskNo + 1).toString();
                    } else {
                        // If no tasks exist yet for this chapter, start from 1
                        this.newTask.task_no = "1";
                    }
                }
                // Check if task_no and chapt_no already exist in tasks
                const taskExists = this.tasks.some(task =>
                    task.task_no === this.newTask.task_no && task.chapt_no === this.newTask.chapt_no
                );

                if (taskExists) {
                    this.errorMessage = "A task with this Task No and Chapter No already exists.";
                    this.showAlert = true;
                    return;
                }

                const token = localStorage.getItem('token');
                const headers = { Authorization: `Bearer ${token}` };

                const response = await axios.post(
                    `/api/tasks`,
                    {
                        task_no: this.newTask.task_no,
                        product_id: parseInt(localStorage.getItem('product_id')),
                        reference: this.newTask.reference,
                        manob: this.newTask.manob,
                        scope: this.newTask.scope.join(','),
                        est_time: this.newTask.est_time,
                        description: this.newTask.description,
                        chapt_no: this.newTask.chapt_no,
                        P1: this.newTask.P1,
                        category: this.newTask.category,
                    },
                    { headers }
                );

                if (response.status === 200) {
                    window.alert('Task added Successfully');
                    this.tasks.push(response.data);
                    this.newTask = {
                        task_no: '',
                        product_id: '',
                        reference: '',
                        manob: '',
                        scope: [],
                        est_time: '',
                        description: '',
                        chapt_no: '',
                        category: '',
                        P1: '',
                    };
                    this.errorMessage = '';
                    this.showAlert = false;
                }
                await this.fetchTasks();
            } catch (error) {
                if (error.isOffline === true) {
                    this.$emit('close');
                    return;
                }
                console.error('Error updating Task:', error.response);


                if (error.response && error.response.data && error.response.data.errors) {
                    // Handle validation errors
                    const validationErrors = error.response.data.errors;

                    // Build an error message from the validation errors
                    let errorMessage = 'Validation errors:';
                    for (const field in validationErrors) {
                        errorMessage += `\n${field}: ${validationErrors[field][0]}`;
                    }

                    this.errorMessage = errorMessage;
                } else {
                    // Handle other errors
                    this.errorMessage = 'An error occurred while updating the task.' + error.response.data.message;
                }

                this.showAlert = true;
            }
        },
        async fetchTasks() {
            try {
                const productId = parseInt(localStorage.getItem('product_id'));
                const token = localStorage.getItem('token');
                if (!token) {
                    console.display('unauthorized');
                    return;
                }

                const headers = {
                    Authorization: `Bearer ${token}`,
                };

                const response = await axios.get(`/api/tasks/products/${productId}`, { headers });
                console.log('task response')
                console.log(response);

                if (response.status === 200) {
                    this.tasks = response.data;
                    console.log('tasks');
                    console.log(this.tasks);
                }
            } catch (error) {
                console.error('Error retrieving tasks:', error);
                // Handle error
            }
        },
        goBack() {
            this.$router.push({ name: 'ViewTasks' });
        },
        close() {
            this.$emit('close'); // Emit an event to indicate the modal should be closed
        },
    },
    async mounted() {
        this.isVisible = true;
        await this.fetchTasks();

    },
}
</script>

<style scoped>
.trainee-list-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    /* Semi-transparent background */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    /* Ensure the modal is on top of other content */
}

/* Style your modal content */
.trainee-list-modal {
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    width: 80%;
    max-width: 800px;
    /* Limit the maximum width of the modal */
    padding: 20px;
    position: relative;
    max-height: 95%;
}

.modal-content {
    position: relative;
    max-height: 90vh;
    overflow-y: auto;
    padding: 15px;
}

.add button {
    width: 200px;
    height: 40px;
    margin-top: 50px;
    margin-bottom: 20px;
    border: 1px solid rgb(0, 96, 134);
    background: #2952c4;
    color: white;
    cursor: pointer;
    text-align: center;
    transition: transform 0.2s, box-shadow 0.2s;
}

.add {
    margin-top: 0;
    height: 90%;
}

button.btn:hover {
    background-color: #0c1a61;
    transition: transform 0.2s, box-shadow 0.2s;
}

h2 {
    margin-top: 10px;
    font-size: 30px;
    margin-bottom: 40px;
}

.form-control.rounded {
    height: 40px;
}

.form-group {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
}

.form-group label {
    width: 120px;
    margin-right: 50px;
    text-align: right;
    margin-bottom: 0px;
}

.form-group input.form-control,
.form-group select.form-control {
    flex: 1;
    width: auto;
    margin-left: 0;
    margin-bottom: 0px;
}

.scope-checkboxes {
    flex: 1;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
}

.scope-checkboxes label {
    flex: 1;
    display: flex;
    justify-content: center;
    gap: 8px;
}

#chapt-no,
#task-no {
    flex: 0 0 80px;
    /* don't grow, don't shrink, fixed 100px */
    width: 80px;
}

.form-control#start_date .form-control#end_date {
    border-radius: 5px;
    width: 25%;
    margin-left: 100px;
    margin-right: 45%;
}

h1 {
    margin-bottom: 20px;
}


.alert {
    position: relative;
    padding: .75rem 1.25rem;
    margin-bottom: 0rem;
    border: 1px solid transparent;
    border-radius: .25rem;
}
</style>